module.exports = __webpack_public_path__ + "static/media/ma-4-1.9b208851.svg";